import {
  getLoginConsentPolicyVersion,
  type LoginComplianceProfile,
} from "./loginComplianceProfile";

export { getLoginConsentPolicyVersion };

/** @deprecated Use getLoginConsentPolicyVersion(profile) */
export const LOGIN_CONSENT_POLICY_VERSION = "2026-07-08-global";

export const LOGIN_CONSENT_STORAGE_KEYS = {
  given: "gdpr_consent_given",
  date: "gdpr_consent_date",
  recordId: "gdpr_consent_record_id",
  policyVersion: "gdpr_consent_policy_version",
  profile: "gdpr_consent_profile",
} as const;

export function createLoginConsentRecordId(): string {
  if (typeof crypto !== "undefined" && "randomUUID" in crypto) {
    return crypto.randomUUID();
  }
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (char) => {
    const random = (Math.random() * 16) | 0;
    const value = char === "x" ? random : (random & 0x3) | 0x8;
    return value.toString(16);
  });
}

export function readStoredLoginConsentRecordId(): string | null {
  try {
    const value = localStorage.getItem(LOGIN_CONSENT_STORAGE_KEYS.recordId);
    return value && value.trim().length > 0 ? value.trim() : null;
  } catch {
    return null;
  }
}

export function readStoredLoginConsentPolicyVersion(): string | null {
  try {
    const value = localStorage.getItem(LOGIN_CONSENT_STORAGE_KEYS.policyVersion);
    return value && value.trim().length > 0 ? value.trim() : null;
  } catch {
    return null;
  }
}

export function readStoredLoginConsentProfile(): LoginComplianceProfile | null {
  try {
    const value = localStorage.getItem(LOGIN_CONSENT_STORAGE_KEYS.profile);
    if (value === "eu_gdpr" || value === "us_hipaa" || value === "global") {
      return value;
    }
    return null;
  } catch {
    return null;
  }
}
